import { getJSON, PASSPORT_HOST, HOME_HOST, MAIN_HOST, HTTP } from './ultile';
import { encryption } from '@utiles/officialStore/index';
import { updateDefaultParam } from '../../plugins/AnalyzePoint';
import globalConfig from '@utiles/officialStore/globalConfig';
import {
  JPPASSPORT_SHORT_HOST,
  JPPASSPORT_USER_JSON,
  JPSTORE_LOGOUT,
  JPPASSPORT_UID_LOGIN,
  JPSTORE_UUID,
  JPPASSPORT_TOKEN_LOGIN
} from './jp';
import { getFingerprint } from '@utiles/officialStore/index';
import { commonEmitUpload } from '../../plugins/AnalyzePoint/index';
import { updateCommonParamsInfo } from '@plugins/biPoint/commonParam';
import { popupType, showPopup } from '@plugins/biPoint/_configWebstoreV35';
import { gameIdTransform } from '@utiles/officialTopupNew/transform';
export const UPDATE_IS_JP_UID_LOGIN = 'update_is_jp_uid_login';
export const UPDATE_IS_LOGIN_POPUP = 'update_is_login_popup';
export const UPDATE_IS_SELECT_ROLE_POPUP = 'update_is_select_role_popup';
export const UPDATE_SWITCH_ROLE_PANEL = 'update_switch_role_panel';
export const UID_LOGIN = 'uid_login';
export const GO_UID_TOKEN_LOGIN = 'go_uid_token_login';
export const CHECK_NEED_VERIFICATION_CODE = 'check_need_verification_code';
export const LOGOUT = 'logout';
export const JUDGE_IS_LOGIN = 'judge_is_login';
export const UPDATE_UID_TOKEN_LOGIN_STATUS = 'update_uid_token_login_status';
export const UPDATE_LOGIN_STATUS = 'update_login_status';
export const UPDATE_LOGIN_TYPE = 'update_login_type';
export const UPDATE_UID = 'update_uid';
export const UPDATE_UID_LOGIN_STATUS = 'update_uid_login_status';
export const UPDATE_SHOW_LOGIN_TYPE = 'update_show_login_type';
export const UPDATE_UID_TYPE_AND_HIDE_VIP_COUPON =
  'update_uid_type_and_hide_vip_coupon';
export const UPDATE_THIRD_LIST = 'update_third_list';
export const GO_ACCOUNT_LOGIN = 'go_account_login';
export const TOGGLE_REMEMBER = 'toggle_remember';
export const SET_ACCOUNT_SELECTER_STATUS = 'set_account_selecter_status';
export const ROLE_ID_LOGIN = 'role_id_login';
export const GENERATE_QR_CODE = 'generate_qr_code';
export const CHECK_QR_CODE_STATUS = 'check_qr_code_status';
export const HANDLE_QR_CODE_LOGIN = 'handle_qr_code_login';
export const UPDATE_IS_JUDGE_LOGIN_END = 'update_is_judge_login_end';

const CHECK_LOGIN_TYPE_SHOW = 'check_login_type_show';
const ACCOUNT_LOGIN_ACTION = 'web_login/login';
const UPDATE_DISPLAY_NAME = 'update_display_name';
const UPDATE_LOGIN_ACCOUNT = 'update_login_account';
const GET_GAME = 'ajax/get_game';
const CHECK_LOGIN_ACTION = 'center/ajax/get_store_user_json';
const UID_LOGIN_ACTION = 'web_store_login/uid_login';
const LOGOUT_ACTION = 'web_store_login/logout';
const UID_TOKEN_LOGIN_ACTION = 'uid_token_login/web_login';
const UID_NEED_CKCODE_ACTION = 'uid_token_login/need_ckcode';
const THIRD_LOGIN_LIST_ACTION = 'ajax/get_login_type';
const ROLE_ID_LOGIN_ACTION = 'center/ajax/roleid_login';
const GENERATE_QR_CODE_ACTION = 'web_qr_code_login/code_generate';
const CHECK_QR_CODE_STATUS_ACTION = 'web_qr_code_login/qr_code_check';
const HANDLE_QR_CODE_LOGIN_ACTION = 'web_qr_code_login/qr_code_login';

export const CHANNEL_NAME = {
  facebook: 'Facebook',
  line: 'Line',
  naver: 'Naver',
  twitter: 'Twitter',
  googleplay: 'Google',
  vk: 'VK',
  apple: 'Apple'
};

export const HOME_PAGE = `https://www.${MAIN_HOST}`;

const thirdLoginParam = globalConfig.assignParamsObj(
  globalConfig.getHrefParamObj(),
  {
    language: ''
  }
);

if (thirdLoginParam.gameId !== undefined) {
  delete thirdLoginParam.gameId;
}

const thirdLoginParamStr = globalConfig.objParamsToStrParams(thirdLoginParam);
export const FB_LOGIN_HREF = `${HTTP}${PASSPORT_HOST}web_facebook/login?${thirdLoginParamStr}`;
export const TWI_LOGIN_HREF = `${HTTP}${PASSPORT_HOST}web_twitter/login?${thirdLoginParamStr}`;
export const LINE_LOGIN_HREF = `${HTTP}${PASSPORT_HOST}web_line/login?${thirdLoginParamStr}`;
export const APPLE_LOGIN_HREF = `${HTTP}${PASSPORT_HOST}web_apple/login?${thirdLoginParamStr}`;
export const GOOGLE_PLAY_LOGIN_HREF = `${HTTP}${PASSPORT_HOST}web_google/login?${thirdLoginParamStr}`;
export const VK_LOGIN_HREF = `${HTTP}${PASSPORT_HOST}web_vk/login?${thirdLoginParamStr}`;

export default {
  state: {
    isLogin: false,
    isJpUidLogin: false,
    isUidLogin: false,
    isUidTokenLogin: false,
    isUidTypeAndHideVipCoupon: false,
    loginType: '',
    displayName: '',
    loginAccount: '',
    uid:
      globalConfig.getLclStorageItem('lid') ||
      globalConfig.getLclStorageItem('userId') ||
      '',
    isLoginPopup: false,
    thirdList: [],
    isSelectRolePopup: false,
    switchRolePanel: false,
    showLoginType: '', // 展示的登陆类型，用于登陆弹窗 1：账号密码登陆， 2：游客登陆
    isRemember: 1, // 是否记住登陆
    showAccountSelecter: false,
    isJudgeLoginEnd: false // 是否已经判断登录结束
  },
  mutations: {
    [SET_ACCOUNT_SELECTER_STATUS](state, status) {
      state.showAccountSelecter = status;
    },
    [UPDATE_SWITCH_ROLE_PANEL](state, status) {
      state.switchRolePanel = status;
    },
    [UPDATE_UID_LOGIN_STATUS](state, status) {
      state.isUidLogin = status;
    },
    [UPDATE_SHOW_LOGIN_TYPE](state, type) {
      state.showLoginType = type;
    },
    [TOGGLE_REMEMBER](state) {
      state.isRemember = Number(!state.isRemember);
    },
    [UPDATE_UID_TOKEN_LOGIN_STATUS](state, status) {
      state.isUidTokenLogin = status;
    },
    [UPDATE_UID_TYPE_AND_HIDE_VIP_COUPON](state, status) {
      state.isUidTypeAndHideVipCoupon = status;
    },
    [UPDATE_LOGIN_STATUS](state, status) {
      state.isLogin = status;
      commonEmitUpload(`succ-login`, {
        event: `succ-login`,
        pageName: 'home',
        type: 'change'
      });
    },
    [UPDATE_LOGIN_TYPE](state, loginType) {
      state.loginType = loginType;
    },
    [UPDATE_UID](state, id) {
      state.uid = id;
    },
    [UPDATE_DISPLAY_NAME](state, name) {
      state.displayName = name;
    },
    [UPDATE_LOGIN_ACCOUNT](state, account) {
      state.loginAccount = account;
    },
    [UPDATE_THIRD_LIST](state, list) {
      state.thirdList = list;
    },
    [UPDATE_IS_LOGIN_POPUP](state, status) {
      state.isLoginPopup = status;
      if (status) {
        showPopup(popupType.loginPopup);
      }
    },
    [UPDATE_IS_JP_UID_LOGIN](state, status) {
      state.isJpUidLogin = status;
    },
    [UPDATE_IS_SELECT_ROLE_POPUP](state, status) {
      state.isSelectRolePopup = status;
    },
    [UPDATE_IS_JUDGE_LOGIN_END](state, status) {
      state.isJudgeLoginEnd = status;
    }
  },
  actions: {
    [JUDGE_IS_LOGIN]({ commit, dispatch, rootGetters }) {
      let host = '';
      let path = '';
      if (rootGetters.isJpPlatform) {
        host = JPPASSPORT_SHORT_HOST;
        path = JPPASSPORT_USER_JSON;
      } else {
        host = PASSPORT_HOST;
        path = CHECK_LOGIN_ACTION;
      }

      return new Promise(resolve => {
        getJSON(HTTP + host + path, {}).then(res => {
          if (parseInt(res.res.result, 10) === 1) {
            commit(UPDATE_IS_LOGIN_POPUP, false);
            commit(UPDATE_DISPLAY_NAME, res.res.data.DISPLAY_NAME);
            commit(UPDATE_LOGIN_ACCOUNT, res.res.data.LOGIN_ACCOUNT);
            commit(UPDATE_UID, res.res.data.UID);
            // 针对 2（补款） | 3（大R支付）时，跳转到新版页面
            const loginType = res.res.data.LOGIN_TYPE || '';
            if ([2, 3].includes(loginType)) {
              // 跳转新版登录页
              // 获取当前的url与参数
              const search = window.location.search;
              const params = new URLSearchParams(search);
              if (params.has('isFromGs')) {
                // 存在则覆盖
                params.set('isFromGs', loginType == 3 ? '1' : '0');
              } else {
                // 不存在则添加
                params.append('isFromGs', loginType == 3 ? '1' : '0');
              }
              // 获取当前的MAINHOST
              const mainHost = globalConfig.getMainHost();
              if (loginType == 3) {
                // 大R支付的话清除登录态
                dispatch(LOGOUT).then(() => {
                  window.location.href = `https://pay.${mainHost}/platform/officialTopupSupplement.html?${params}`;
                });
              } else {
                // 补款的话直接跳转补款页
                window.location.href = `https://pay.${mainHost}/platform/officialTopupSupplement.html?${params}`;
              }
            }
            commit(
              UPDATE_LOGIN_TYPE,
              res.res.data.LOGIN_TYPE ? res.res.data.LOGIN_TYPE : ''
            );
            commit(UPDATE_LOGIN_STATUS, true);
            // 全球平台因V3不支持uid登录，如果进入为uid登录，退出登录
            if (res.res.data.IS_UID_LOGIN && +res.res.data.IS_UID_LOGIN === 1) {
              if (rootGetters.isJpPlatform) {
                commit(UPDATE_UID_LOGIN_STATUS, true);
              } else {
                dispatch(LOGOUT).then(() => {
                  window.location.reload();
                });
              }
            } else {
              commit(UPDATE_UID_LOGIN_STATUS, false);
            }
            if (res.res.data.LOGIN_TYPE && +res.res.data.LOGIN_TYPE === 11) {
              commit(UPDATE_UID_TYPE_AND_HIDE_VIP_COUPON, true);
            } else {
              commit(UPDATE_UID_TYPE_AND_HIDE_VIP_COUPON, false);
            }
            updateDefaultParam('loginAccount', res.res.data.LOGIN_ACCOUNT);
            updateDefaultParam('ext14', res.res.data.UID);
            updateCommonParamsInfo({
              loginAccount: res.res.data.LOGIN_ACCOUNT,
              uid: res.res.data.UID
            });
            window.webstorev35DataLayer.push({
              eventName: 'login',
              eventType: res?.res?.data?.LOGIN_PATH || ''
            });
          } else {
            dispatch(CHECK_LOGIN_TYPE_SHOW).then(() => {
              commit(UPDATE_IS_LOGIN_POPUP, true);
            });
          }
          commit(UPDATE_IS_JUDGE_LOGIN_END, true);
          resolve(parseInt(res.res.result, 10) === 1);
        });
      });
    },
    [CHECK_LOGIN_TYPE_SHOW]({ commit, rootState, rootGetters }) {
      return new Promise(resolve => {
        if (rootGetters.isJpPlatform) {
          commit(UPDATE_SHOW_LOGIN_TYPE, 2);
          resolve();
          return;
        }
        getJSON(HTTP + HOME_HOST + GET_GAME, gameIdTransform({
          gameID: rootState.gameId
        })).then(({ res }) => {
          if (parseInt(res.result, 10) === 1) {
            const userMode = res?.data?.extra_info?.USER_TYPE;
            commit(UPDATE_SHOW_LOGIN_TYPE, +userMode || 0);
            resolve();
          }
        });
      });
    },
    [UID_LOGIN]({ commit, dispatch, rootGetters }, params) {
      let url = HTTP + PASSPORT_HOST + UID_LOGIN_ACTION;
      let getParams = params;
      if (rootGetters.isJpPlatform) {
        url = JPPASSPORT_SHORT_HOST + JPPASSPORT_UID_LOGIN;
        getParams = {
          game_id: params.gameId,
          user_id: params.uid
        };
      }
      return new Promise((resolve, reject) => {
        getJSON(url, gameIdTransform(getParams)).then(({ res }) => {
          if (parseInt(res.result, 10) === 1) {
            commit(UPDATE_LOGIN_STATUS, true);
            dispatch(JUDGE_IS_LOGIN);
            resolve({
              result: true,
              msg: 'succ'
            });
          } else {
            reject({
              result: false,
              msg: res?.msg
            });
          }
        });
      });
    },
    [LOGOUT]({ rootState, rootGetters }) {
      let host = '';
      let path = '';
      if (rootGetters.isJpPlatform) {
        host = JPPASSPORT_SHORT_HOST;
        path = JPSTORE_LOGOUT;
      } else {
        host = PASSPORT_HOST;
        path = LOGOUT_ACTION;
      }

      return new Promise(resolve => {
        getJSON(HTTP + host + path, {
          language: rootState.lang
        }).then(res => {
          updateCommonParamsInfo({
            loginAccount: '',
            uid: '',
            serverId: '',
            roleName: '',
            roleId: ''
          });
          resolve({
            result: parseInt(res.result, 10) === 1
          });
        });
      });
    },
    [UPDATE_UID]({ commit }, param) {
      commit(UPDATE_UID, param);
      globalConfig.setLclStorageItem('lid', param);
    },
    [GO_ACCOUNT_LOGIN]({ rootState, state, dispatch }, param) {
      const params = {
        uname: param.account,
        password: encryption(param.password),
        language: rootState.lang,
        game_id: rootState.gameId,
        web_source: 'platform',
        timeZone: encodeURIComponent(globalConfig.getTimeZone()),
        remember: state.isRemember
      };
      return new Promise(async resolve => {
        let url = HTTP + PASSPORT_HOST + ACCOUNT_LOGIN_ACTION;
        getJSON(url, gameIdTransform(params)).then(({ errmsg, res }) => {
          if (parseInt(res.result, 10) === 1) {
            dispatch(JUDGE_IS_LOGIN);
            resolve({
              result: true,
              msg: 'succ'
            });
          } else {
            resolve({
              result: false,
              msg: errmsg
            });
          }
        });
      });
    },
    [GO_UID_TOKEN_LOGIN]({ state, commit, dispatch, rootGetters }, param) {
      return new Promise(async resolve => {
        let url = HTTP + PASSPORT_HOST + UID_TOKEN_LOGIN_ACTION;
        // 通用参数
        const commonParams = {
          language: state.lang,
          // 2017.1.17
          // 用来标记从平台登录页登录注册的数据，并在后端进行过滤（避免非h5游戏产生web端新用户数据）
          web_source: 'platform',
          timeZone: encodeURIComponent(globalConfig.getTimeZone()),
          gameId: param.gameId,
          packageName: param.packageName
        };
        // 全球参数
        const globalParams = {
          uid: param.uid,
          token: param.token,
          ckcode: param.ckcode
        };
        // 日本参数
        const jpParams = {
          code: param.token
        };
        // 最终提交参数
        let getParams = {};
        if (rootGetters.isJpPlatform) {
          url = JPPASSPORT_SHORT_HOST + JPPASSPORT_TOKEN_LOGIN;
          const uuid = await getFingerprint(JPSTORE_UUID);
          getParams = Object.assign(commonParams, jpParams, {
            loginId: uuid
          });
        } else {
          getParams = Object.assign(commonParams, globalParams);
        }

        getJSON(url, gameIdTransform(getParams)).then(({ errmsg, res }) => {
          if (parseInt(res.result, 10) === 1) {
            dispatch(JUDGE_IS_LOGIN);
            commit(UPDATE_UID_TOKEN_LOGIN_STATUS, true);
            resolve({
              result: true
            });
          } else {
            resolve({
              result: false,
              msg: errmsg
            });
          }
        });
      });
    },
    [CHECK_NEED_VERIFICATION_CODE]() {
      return new Promise((resolve, reject) => {
        getJSON(HTTP + PASSPORT_HOST + UID_NEED_CKCODE_ACTION, {})
          .then(res => {
            if (+res.res.result === 1) {
              resolve({
                result: 1,
                data: res.res.data
              });
            } else {
              resolve({
                result: 0,
                msg: res?.res.msg
              });
            }
          })
          .catch(err => reject(err));
      });
    },
    // 更新串接登录列表
    [UPDATE_THIRD_LIST]({ commit, rootState, rootGetters }) {
      return new Promise(resolve => {
        if (rootGetters.isJpPlatform) {
          resolve();
          return;
        }
        getJSON(HTTP + HOME_HOST + THIRD_LOGIN_LIST_ACTION, gameIdTransform({
          gameId: rootState.gameId
        })).then(json => {
          if (parseInt(json.res.result, 10) === 1) {
            let res = [];
            if (
              Object.prototype.toString.call(json.res.data) === '[object Array]'
            ) {
              json.res.data.map(item => {
                if (!/^(gamecenter|migrate_code)$/.test(item)) {
                  res.push(item);
                }
              });
            }

            commit(UPDATE_THIRD_LIST, res);
          }
          resolve();
        });
      });
    },
    [ROLE_ID_LOGIN]({ state, commit, dispatch }, param) {
      return new Promise(async resolve => {
        let url = JPPASSPORT_SHORT_HOST + ROLE_ID_LOGIN_ACTION;
        // 通用参数
        const commonParams = {
          language: state.lang,
          // 2017.1.17
          // 用来标记从平台登录页登录注册的数据，并在后端进行过滤（避免非h5游戏产生web端新用户数据）
          web_source: 'platform',
          timeZone: encodeURIComponent(globalConfig.getTimeZone()),
          packageName: param.packageName || '',
          game_id: param.game_id,
          role_id: param.role_id
        };
        getJSON(url, gameIdTransform(commonParams)).then(({ errmsg, res }) => {
          if (parseInt(res.result, 10) === 1) {
            dispatch(JUDGE_IS_LOGIN);
            resolve({
              result: true,
              data: res.data || {}
            });
          } else {
            resolve({
              result: false,
              msg: errmsg
            });
          }
        });
      });
    },
    [GENERATE_QR_CODE]({ rootState }, params) {
      return new Promise((resolve, reject) => {
        getJSON(HTTP + PASSPORT_HOST + GENERATE_QR_CODE_ACTION, gameIdTransform(params))
          .then(({ res }) => {
            resolve(res);
          })
          .catch(err => reject(err));
      });
    },
    [CHECK_QR_CODE_STATUS]({ rootState }, params) {
      return new Promise((resolve, reject) => {
        getJSON(HTTP + PASSPORT_HOST + CHECK_QR_CODE_STATUS_ACTION, gameIdTransform(params))
          .then(({ res }) => {
            resolve(res);
          })
          .catch(err => reject(err));
      });
    },
    [HANDLE_QR_CODE_LOGIN]({ dispatch }, params) {
      return new Promise((resolve, reject) => {
        getJSON(HTTP + PASSPORT_HOST + HANDLE_QR_CODE_LOGIN_ACTION, gameIdTransform(params))
          .then(({ res }) => {
            if (parseInt(res.result, 10) === 1) {
              dispatch(JUDGE_IS_LOGIN);
            }
            resolve(res);
          })
          .catch(err => reject(err));
      });
    }
  }
};
